const SESSION_KEY = 'eventatv_geo_country_v1'
const SESSION_MS = 60 * 60 * 1000

type Cached = {cc: string; t: number}

type IpapiPayload = {
  error?: boolean
  country_code?: string | null
}

function isIpapiPayload(v: unknown): v is IpapiPayload {
  if (!v || typeof v !== 'object') return false
  return true
}

function readSessionCountry(): string | null {
  if (typeof window === 'undefined' || !window.sessionStorage) return null
  try {
    const raw = window.sessionStorage.getItem(SESSION_KEY)
    if (!raw) return null
    const c = JSON.parse(raw) as Cached
    if (!c || typeof c.cc !== 'string' || typeof c.t !== 'number') return null
    if (Date.now() - c.t > SESSION_MS) {
      window.sessionStorage.removeItem(SESSION_KEY)
      return null
    }
    return c.cc.toUpperCase()
  } catch {
    return null
  }
}

function writeSessionCountry(cc: string) {
  if (typeof window === 'undefined' || !window.sessionStorage) return
  try {
    const payload: Cached = {cc: cc.toUpperCase(), t: Date.now()}
    window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(payload))
  } catch {
    /* private mode / quota */
  }
}

const IPAPI_BASE = 'https://ipapi.co/json/'

/**
 * Best-effort country code (ISO 3166-1 alpha-2) from a client-side
 * request. Uses a short same-tab cache to avoid a network call on every
 * client route change.
 */
export async function fetchClientCountryCode(
  signal?: AbortSignal,
): Promise<string | null> {
  if (typeof window === 'undefined') return null
  const cached = readSessionCountry()
  if (cached) return cached
  const res = await fetch(IPAPI_BASE, {
    credentials: 'omit',
    signal,
  })
  if (!res.ok) return null
  const json: unknown = await res.json()
  if (!isIpapiPayload(json) || json.error) return null
  const code = json.country_code
  if (typeof code !== 'string' || code.length < 2) return null
  const cc = code.toUpperCase().slice(0, 2)
  if (cc.length !== 2) return null
  writeSessionCountry(cc)
  return cc
}
